<template>
  <el-carousel arrow="never">
    <el-carousel-item v-for="(item, index) in formated" :key="index">
      <a v-if="item.linkUrl" :href="item.linkUrl">
        <div class="banner" :style="{'background-image': 'url('+ item.coverUrl +')'}">
          <!--<div class="banner-content">
            <div class="banner-text">
              <p class="title">重塑 “互联网+” 时代的</p>
              <h1>智能入口</h1>
              <h5 class="title-bg">做数据驱动的智慧化民生服务提供商</h5>
              <p class="title-details">这是描述文字描述文字买书文字这是描述文字描述文字买书文字这是描述文字描述文字买书文字</p>
              <button class="btn-know">了解我们 »</button>
            </div>
          </div>-->
        </div>
      </a>
      <div class="banner"
           v-else
           :style="{'background-image': 'url('+ item.coverUrl +')'}">
      <!--<div class="banner-content">
        <div class="banner-text">
          <p class="title">重塑 “互联网+” 时代的</p>
          <h1>智能入口</h1>
          <h5 class="title-bg">做数据驱动的智慧化民生服务提供商</h5>
          <p class="title-details">这是描述文字描述文字买书文字这是描述文字描述文字买书文字这是描述文字描述文字买书文字</p>
          <button class="btn-know">了解我们 »</button>
        </div>
      </div>-->
      </div>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
  export default {
    name: 'headerBar',
    data () {
      return {}
    },
    props: {
      banners: {
        required: true,
        type: Array
      }
    },
    computed: {
      formated () {
        let webReg = 'http';
        let format = this.banners.map(n => {
          if (n.coverUrl.indexOf(webReg) >= 0) {
            return n;
          }
          n.coverUrl = window.config.host + n.coverUrl
          return n;
        });

        return format;
      }
    }
  };
</script>

<style lang="scss">
  @import '../assets/style/base.scss';
  @import '../assets/style/public.scss';

  .el-carousel {
    $h: 440px;
    $theme-color: #00ccff;
    width: 100%;
    height: $h;
    overflow: hidden;
    .el-carousel__container {
      width: 100%;
      height: $h;
    }
    .el-carousel__indicators {
      width: 250px;
      height: 30px;
      position: absolute;
      bottom: 150px;
      left: 50%;
      transform: translate(-50%, 0);
      display: flex;
      justify-content: center;
      align-items: center;
      .el-carousel__indicator {
        width: 24px;
        height: 24px;
        border-radius: 100%;
        border: 1px solid transparent;
        margin: 0 12px;
        position: relative;
        padding: 0;
        .el-carousel__button {
          width: 7px;
          height: 7px;
          display: inline-block;
          border-radius: 50%;
          opacity: 1;
          background: #fff;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .is-active {
        border-color: $theme-color;
        .el-carousel__button {
          background: $theme-color !important;
        }
      }
    }
  }

  .banner {
    $theme-color: #00ccff;
    $h: 440px;
    width: 100%;
    height: $h;
    background-repeat: no-repeat;
    -webkit-background-size: cover;
    background-size: cover;
    background-position: center center;
    .banner-content {
      @include public_content();
      height: 100%;
      position: relative;
      .banner-text {
        width: 600px;
        height: 340px;
        padding-top: 60px;
        .title {
          font-size: 20px;
          color: $theme-color;
        }
        h1 {
          font-size: 42px;
          font-weight: 800;
          margin: 25px 0;
          color: $theme-color;
        }
        .title-details {
          width: 490px;
          padding-left: 9px;
          font-size: 14px;
          color: #fff;
        }
        .btn-know {
          width: 110px;
          height: 32px;
          font-size: 14px;
          border-radius: 5px;
          margin-top: 30px;
          color: $theme-color;
          border: 1px solid $theme-color;
          background-color: transparent;
          &:hover {
            background: $theme-color;
            color: #fff;
            border: none;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/BannerSwitch.vue